import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setLoginSuccess } from '../../../reducers/userDetailsSlice';
import {
  BDDTokenResponse,
  injectBDDTokensAndReturnUserDetails,
} from '../../../auth/bddTokenUtils';
import { updateLanguage } from '@/reducers/translationSlice';

const useBddManualLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const isBdd = urlParams.get('isBdd') === 'true';
    if (!isBdd) return;

    const bddManualLoginHandler = async (event: any) => {
      const response = event.detail;
      if (!response) return;
      try {
        injectBDDTokensAndReturnUserDetails(response as BDDTokenResponse);

        localStorage.setItem('redirectUrl', response.redirectUrl);

        dispatch(setLoginSuccess());
        dispatch(updateLanguage({ language: response.userLanguage || 'en' }));
      } catch (error) {
        console.error('Error during BDD login:', error);
      }
    };

    document.addEventListener(
      'bddManualLogin',
      bddManualLoginHandler as EventListener,
    );

    return () => {
      document.removeEventListener(
        'bddManualLogin',
        bddManualLoginHandler as EventListener,
      );
    };
  }, [dispatch, navigate]);
};

export default useBddManualLogin;
